import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { sv } from "date-fns/locale";
import { DateTimePicker , MuiPickersUtilsProvider,KeyboardDateTimePicker } from '@material-ui/pickers';
import Grid from "@material-ui/core/Grid";
import moment from 'moment-timezone';
import { isUndefined, isNull } from 'lodash'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

function TextSettings(props) {
  const placeholder = props.intl.formatMessage({ id: 'Input.date.start.placeHolder'})
  return (
    <Grid item xs="12">
      <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
        <Fragment>
            <KeyboardDateTimePicker
            inputVariant="outlined"
            label={<IntlMessages id="Input.date.start.label"/>}
            size="small"
            cancelLabel={<IntlMessages id="Cancel"/>}
            fullWidth
            format="yyyy-MM-dd HH:mm"
            variant="outlined"
            ampm={false}
            animateYearScrolling
            value={props.startDate}
            onChange={(date) => props.setStartDate(date)}
            emptyLabel=""        
            placeholder={placeholder}
            clearable
            clearLabel={<IntlMessages id="Date.delete"/>}
            invalidDateMessage={<IntlMessages id="Date.inValid"/>}
            KeyboardButtonProps={{
              "class": "px-0 m-0 btn btn-sm"
            }}         
            />
        </Fragment>
      </MuiPickersUtilsProvider>  
    </Grid>
  )
}
export default injectIntl(TextSettings);